export default __webpack_public_path__ + "static/media/yellow_3.a0766daf.png";